import React from 'react';

const DayHourExport = ({ datasets }) => {
    return (
        <>
            {datasets.map((dataset, rowIndex) => {
                let maxTotal = 0;
                let maxDate = "";

                dataset.data.forEach(item => {
                    if (item.total > maxTotal) {
                        maxTotal = item.total;
                        maxDate = item.dh;
                    }
                });

                return (
                    <table className="d-none export-all" id={"day-hour-export"}>
                        <thead>
                            <tr>
                                <th>Sentido</th>
                                <th>Data/hora</th>
                                <th>Passagens</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={`row-${rowIndex}`}>
                                <td>{dataset.title}</td>
                                <td>{maxDate}</td>
                                <td>{maxTotal}</td>
                            </tr>
                        </tbody>
                    </table>
                );
            })}
        </>
    );
};

export default DayHourExport;